import { useUI } from "providers/UIProvider"

import { Box, Flex, Text } from "@chakra-ui/react"

import IconButton from "components/UI/molecules/IconButton"
import moment from "moment"
import { IHolidayItemProps } from "./HolidaysModalTypes"

const HolidayItem: React.FC<IHolidayItemProps> = ({ holiday, handleDeleteClick, handleEditClick }) => {
  const { T } = useUI()

  const { fromDateTime, toDateTime } = holiday

  const startDate = new Date(fromDateTime)
  const endDate = new Date(toDateTime)

 
  return (
    <Box
      bg="input_border_color_primary"
      borderRadius="base"
      padding="15px"
      mb="16px"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex>
          <Text fontSize="base" mr="25px" fontFamily="heading">
            {moment(startDate).format("HH:mm - DD MMMM")} - {T("holiday.form.start_date_prefix")}
          </Text>
          <Text fontSize="base" fontFamily="heading">
          {moment(endDate).format("HH:mm - DD MMMM")} - {T("holiday.form.end_date_prefix")}
          </Text>
        </Flex>
        <Flex>
          <Box mr="5px">
            <IconButton
              iconName="edit"
              onClick={()=>handleEditClick(holiday)}
              variant="solid"
            />
          </Box>
          <Box>
            <IconButton
              iconName="close"
              onClick={()=>handleDeleteClick(holiday)}
              variant="solid"
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}

export default HolidayItem
